import styled from "styled-components";
import { AccountCircleOutlined as AccountCircleOutlinedIcon } from "@mui/icons-material";

interface MenuItemContainerProps {
  isActive?: boolean;
  isSubmenu?: boolean;
  isFirstSubmenuItem?: boolean;
  isFirstItem?: boolean;
  $disabled?: boolean;
}
interface subMenuWrapperProps {
  isSubmenu?: boolean;
  isActive?: boolean;
  $disabled?: boolean;
}
interface MenuBadgeProps {
  isActive?: boolean;
}

const borderColor = "#e0e0e0";

const MenuItemContainer = styled.div<MenuItemContainerProps>`
  min-height: 44px;
  position: relative;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: Lato, sans-serif;
  display: flex;
  align-items: center;
  padding: ${(props) => (props.isSubmenu ? "6px 12px" : "6px 12px")};
  margin: ${(props) => (props.isSubmenu ? "0" : "4px 8px")};
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  border-radius: ${(props) => (props.isSubmenu ? "0px" : "10px")};
  color: ${(props) =>
    props.$disabled
      ? "#a0a0a0"
      : props.isSubmenu
      ? props.isActive
        ? "#0095ff"
        : "#434343"
      : props.isActive
      ? "#0095ff"
      : "#18181b"};
  background-color: ${(props) =>
    props.isActive
      ? props.isSubmenu
        ? "transparent"
        : "#e6f4ff"
      : "transparent"};
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    color: ${(props) => (props.$disabled ? "#a0a0a0" : "#0095ff")};
    background-color: ${(props) =>
      props.$disabled
        ? "transparent"
        : props.isSubmenu
        ? "transparent"
        : "#f0f7ff"};
  }
`;

const SideMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  justify-content: flex-start;
  background-color: rgba(255, 255, 255, 1);
  border-right: 1px solid ${borderColor};
  position: relative;
`;

const MenuWrapper = styled.div`
  margin-top: 0px;
`;
const StyledNavLink = styled.div`
  text-decoration: none;
`;
const UserInfoWrapper = styled.div`
  position: absolute;
  bottom: 0;
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
`;
const Container = styled.div`
  position: absolute;
  width: 80%;
  height: 80%;
  display: flex;
  align-items: center;
  margin-left: 20px;
`;
const IconWrapper = styled.div`
  margin-right: 15px;
`;

const UserIcon = styled(AccountCircleOutlinedIcon)`
  width: 35px;
  height: 35px;
`;

const MenuItemText = styled.span<subMenuWrapperProps>`
  font-family: Lato, sans-serif;
  font-weight: ${(props) => (props.isSubmenu ? (props.isActive ? 600 : 400) : 600)};
  color: ${(props) =>
    props.$disabled
      ? "#a0a0a0"
      : props.isSubmenu
      ? props.isActive
        ? "#0095ff"
        : "#434343"
      : props.isActive
      ? "#0095ff"
      : "#18181b"};
  font-size: ${(props) => (props.isSubmenu ? "13px" : "14px")};
`;

const SubMenuWrapper = styled.div`
  position: relative;
  margin-left: 20px;
  &::before {
    content: "";
    position: absolute;
    left: 19.5px;
    top: 12px;
    bottom: 12px;
    width: 1px;
    background-color: #e0e0e0;
    z-index: 1;
  }
`;

export const Separator = styled.div`
  min-width: ${({ theme }) => theme.spacing(25)};
  height: ${({ theme }) => theme.spacing(0.25)};
  background-color: ${({ theme }) => theme.colors.grey[1700]};
  margin-top: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  margin-left: 8%;
  margin-right: ${({ theme }) => theme.spacing(3.5)};
`;
const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const IconContainer = styled.div`
  right: 12px;
  position: absolute;
  display: flex;
  align-items: center;
`;

interface SubmenuDotProps {
  isActive?: boolean;
}

const SubmenuDot = styled.div<SubmenuDotProps>`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: ${(props) => (props.isActive ? "#0095ff" : "#c4c4c4")};
  margin-right: 12px;
  margin-left: 4px;
  flex-shrink: 0;
  z-index: 2;
`;

const MenuBadgeContainer = styled.div<MenuBadgeProps>`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: ${(props) => (props.isActive ? "#0095ff" : "#f4f4f5")};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  transition: all 0.2s ease;

  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    filter: ${(props) => (props.isActive ? "brightness(0) invert(1)" : "none")};
  }

  svg {
    width: 18px;
    height: 18px;
    color: ${(props) => (props.isActive ? "#ffffff" : "#18181b")} !important;
  }
`;

export {
  SideMenuWrapper,
  MenuWrapper,
  MenuItemContainer,
  StyledNavLink,
  MenuItemText,
  UserInfoWrapper,
  IconWrapper,
  UserIcon,
  Container,
  SubMenuWrapper,
  ImageContainer,
  IconContainer,
  SubmenuDot,
  MenuBadgeContainer,
};
